<template>
  <div>
    <CrudList
      title="Estadías"
      storeName="Rent_order_paid"
      parentStoreName="Liquidations"
      labelAddNew="Agregar"
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      :canExport="true"
      :filters="filters"
      sortable
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/liquidations'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: 'Liquidar',
          disabled: true,
          href: '#'
        }
      ]"
    >
      /* ----- HEADER FILTERS------------------------- */
      <template v-slot:head-list>
        <v-row>
          <v-col cols="6">
            <AutocompleteInput
                @selected="getAutocompleteUsers"
                :items="displayUsers"
                item-id="id"
                :is-multiple="true"
                item-text="full_name"
                label="Host"
                :loading="loadingUsers"
                :onSearch="onSearchUsers"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="data.item._loading">{{ data.item.full_name }}</span>
                    <span v-else>
                      {{ data.item.full_name }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </AutocompleteInput>
          </v-col>
          <v-col cols="6">
            <AutocompleteInput
                @selected="getAutocompleteSpots"
                :items="displaySpots"
                item-id="id"
                item-text="address"
                :is-multiple="true"
                label="Spots"
                :loading="loadingSpots"
                :onSearch="onSearchSpots"
            >
              <template v-slot:list_selection="{ selection }">
                {{ selection.alias_id }} {{ selection.address }}
                {{ selection.unit ? selection.unit : "" }}
                ({{ selection.user ? `${selection.user.name || ""} ${selection.user.last_name || ""}` : "" }})
              </template>
            </AutocompleteInput>
          </v-col>
          <v-col>
            <v-select
              label="Mes"
              :items="months"
              item-text="name"
              item-value="value"
              v-model="data.months"
              solo
                    hide-details="auto"
                    class="input-base"
                    append-icon="$caretDownFormIcon"
              clearable
            >
            </v-select>
          </v-col>
          <v-col>
            <v-select
              label="Estado"
              :items="status_payments"
              item-text="name"
              item-value="value"
              v-model="data.status_payment"
              solo
                    hide-details="auto"
                    class="input-base"
                    append-icon="$caretDownFormIcon"
              clearable
            >
            </v-select>
          </v-col>
          <v-col>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
              loading
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="data.year"
                  label="Año"
                  solo
                    hide-details="auto"
                    class="input-base"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-card>
                <vue-element-loading
                  background-color="white"
                  :active="load_date_picker"
                  spinner="bar-fade-scale"
                  color="#335C9D"
                />
                <v-date-picker
                  ref="picker"
                  v-model="date"
                  :active-picker="type_picker"
                  no-title
                  scrollable
                  @click:year="saveYear"
                >
                </v-date-picker>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </template>
      /* ----HEADER CELL------------------------------ */
      <template v-slot:[`head.liquidate`]="{ options }">
        <v-btn @click="setLiquidate(options)">
          Liquidar
        </v-btn>
        <div class="d-flex align-center">
          <v-checkbox
            label="All"
            v-model="item_all"
            :value="'all'"
            hide-details
            class="my-0 me-2"
          ></v-checkbox>
        </div>
      </template>

      /* ---- BODY CELL ------------------------------ */
      <template v-slot:user="{ item }">
        {{
          item.spot && item.spot.user_id && item.spot.user_id
            ? `${item.spot.user_id.name || ""} ${item.spot.user_id.last_name ||
                ""}`
            : ""
        }}
      </template>
      <template v-slot:spot="{ item }">
        {{ item.spot && item.spot.address ? item.spot.address : "" }}
        {{ item.spot && item.spot.unit ? item.spot.unit : "" }}
      </template>
      <template v-slot:price="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{ item.price || 0 }}
        </p>
      </template>
      <template v-slot:price_discount="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{ Number(item.price_discount || 0) }}
        </p>
      </template>
      <template v-slot:liquidate="{ item }">
        <v-checkbox
          v-show="validateLiquidateChecked(item)"
          v-model="data.liquidation"
          :value="item.id"
        >
        </v-checkbox>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapState } from "vuex";
import AutocompleteInput from "@/components/AutocompleteInput";
import VueElementLoading from "vue-element-loading";
import { format } from "currency-formatter";
import debounce from "lodash/debounce";
import swal from "sweetalert";
export default {
  components: { CrudList, AutocompleteInput, VueElementLoading },
  async created() {
    this.$store.dispatch("Users/getListAll", {
      search: "",
      limit: 10,
      sorting_column: "name",
    });
    this.$store.dispatch("Spots/getListAll", {
      search: "",
      limit: 10,
      sorting_column: "name",
    });
    this.filters.status_payment = this.options_status_payments;
  },
  computed: {
    ...mapState({
      users: (state) => state.Users.list,
      spots: (state) => state.Spots.list,
    }),
    displayUsers() {
      if (this.loadingUsers) {
        // Retornamos un item ficticio con _loading
        return [{ _loading: true, full_name: "Buscando..." }];
      }
      return this.users;
    },
    displaySpots() {
      if (this.loadingSpots) return [{ _loading: true, address: "Buscando..." }];
      return this.spots;
    }
  },
  watch: {
    item_all: {
      async handler(val, old_val) {
        if (val === "all") {
          await this.updatedLiquidateAll();
        }
        if (old_val === "all" && !val && !this.change_liquidation_automatic) {
          this.data.liquidation = [];
        }
        this.change_liquidation_automatic = false;
      },
      immediate: true,
    },
    "data.liquidation": {
      handler(val) {
        if (
          (this.item_all === "all" &&
            val &&
            val.length !== this.tmp_all_liquidations.data.length) ||
          val.length === 0
        ) {
          this.change_liquidation_automatic = true;
          this.item_all = null;
        }
        if (
          this.item_all !== "all" &&
          val &&
          val.length === this.tmp_all_liquidations.data.length &&
          val.length > 0
        ) {
          this.item_all = "all";
        }
      },
    },
    "data.users_spot": {
      async handler(val) {
        this.filters.users_spot = val;
        this.$store.dispatch("Spots/getListAll", {
          users: val,
        });
        await this.updatedLiquidateAll();
      },
    },
    "data.status_payment": {
      async handler(val) {
        const status_payment = val || this.options_status_payments;
        this.filters.status_payment = status_payment;
        await this.updatedLiquidateAll();
      },
    },
    "data.spots": {
      async handler(val) {
        this.filters.spots = val;
        await this.updatedLiquidateAll();
      },
    },
    "data.months": {
      async handler(val) {
        this.filters.months = val;
        await this.updatedLiquidateAll();
      },
    },
    "data.year": {
      async handler(val) {
        this.filters.year = val;
        await this.updatedLiquidateAll();
      },
    },
    menu: {
      handler(val) {
        const self = this;
        self.load_date_picker = true;
        val &&
          this.$nextTick(() => {
            self.load_date_picker = true;
            self.type_picker = "MONTH";
            setTimeout(() => {
              self.type_picker = "YEAR";
              setTimeout(() => {
                self.load_date_picker = false;
              }, 200);
            }, 100);
          });
      },
    },
  },
  data: () => ({
    tmp_all_liquidations: {
      filters: {},
      data: [],
    },
    change_liquidation_automatic: false,
    date: new Date().toISOString().substr(0, 4),
    menu: false,
    modal: false,
    item_all: null,
    type_picker: "YEAR",
    load_date_picker: false,
    offsetTop: 0,
    filters: {
      users_spot: [],
      months: null,
      spots: [],
      year: null,
      status_payment: null,
    },
    data: {
      users_spot: [],
      months: null,
      liquidation: [],
      status_payment: null,
      spots: [],
      year: null,
    },
    status_payments: [
      { name: "Paid (Estadía pagada, falta liquidar)", value: "paid" },
      {
        name: "Liquidated (Estadía ya liquidada al usuario)",
        value: "liquidated",
      },
      {
        name: "Finished (Finalizada antes del horario)",
        value: "finished",
      },
    ],
    options_status_payments: ["paid", "liquidated", "finished"],
    loadingUsers: false,
    loadingSpots: false,
    months: [
      { name: "Enero", value: 1 },
      { name: "Febrero", value: 2 },
      { name: "Marzo", value: 3 },
      { name: "Abril", value: 4 },
      { name: "Mayo", value: 5 },
      { name: "Junio", value: 6 },
      { name: "Julio", value: 7 },
      { name: "Agosto", value: 8 },
      { name: "Septiembre", value: 9 },
      { name: "Octubre", value: 10 },
      { name: "Noviembre", value: 11 },
      { name: "Diciembre", value: 12 },
    ],
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    getAutocompleteUsers(users) {
      this.data.users_spot = users;
    },
    getAutocompleteSpots(spots) {
      this.data.spots = spots;
    },
    onSearchSpots(query) {
      if (!query || query.length < 2) return;

      this.loadingSpots = true;
      this.debouncedSearchSpots(query);
    },
    debouncedSearchSpots: debounce(async function(query) {
      try {
        await this.$store.dispatch("Spots/getListAll", { search: query, limit: 30 });
      } finally {
        this.loadingSpots = false;
      }
    }, 300),
    onSearchUsers: function(query) {
      if (!query || query.length < 2) return;

      // Activamos el loader inmediatamente
      this.loadingUsers = true;

      // Llamada a la función debounced que hace la búsqueda
      this.debouncedSearch(query);
    },

    debouncedSearch: debounce(async function(query) {
      try {
        await this.$store.dispatch("Users/getListAll", {
          search: query,
          limit: 30,
          sorting_column: "name",
        });
      } finally {
        this.loadingUsers = false;
      }
    }, 300),
    async setLiquidate(opt) {
      swal({
        title: "Cargando...",
        text: "Por favor, espere un momento.",
        icon: "info",
        buttons: false,
      });
      await this.$store
        .dispatch("Liquidations/liquidate", {
          liquidation_ids: this.data.liquidation,
        })
        .then((resp) => {
          swal.close();
          swal(
            "Estadias Liquidadas",
            "Las estadias fueron liquidadas exitosamente",
            "success"
          );
        });
      await this.$store.dispatch("Rent_order_paid/getList", opt);
    },
    changeStatusSpanish(status) {
      let resp = "";
      switch (status) {
        case "pending":
          resp = "Pendiente";
          break;
        case "liquidated":
          resp = "Liquidado";
          break;
        default:
          resp = status;
          break;
      }
      return resp;
    },
    showItem: (item) => {
      let address = item.address || "";
      if (address.length > 25) {
        address = address.substring(0, 25) + "...";
      }
      return `${address || ""} (${
        item.user && item.user
          ? `${item.user.name || ""} ${item.user.last_name || ""}`
          : ""
      })`;
    },
    filterSpot(item, query, item_text) {
      return (
        (item[item_text] && item[item_text].indexOf(query) > -1) ||
        (item.user && item.user.name && item.user.name.indexOf(query) > -1) ||
        (item.user &&
          item.user.last_name &&
          item.user.last_name.indexOf(query) > -1) ||
        (item["alias_id"] && item["alias_id"].toString().indexOf(query) > -1)
      );
    },
    saveYear(year) {
      this.$refs.menu.save(year);
      this.type_picker = "MONTH";
      this.data.year = year;
      this.menu = false;
    },
    async updatedLiquidateAll() {
      if (
        JSON.stringify(this.filters) !==
        JSON.stringify(this.tmp_all_liquidations.filters)
      ) {
        const all_rent_orders = await this.$store.dispatch(
          "Rent_orders/getListAll",
          { show_all: "enable", ...this.filters }
        );
        const orders_paid = all_rent_orders.filter(
          (order) => order.status_payment === "paid"
        );
        const rent_orders = orders_paid.map((order) => order.id);
        this.tmp_all_liquidations.data = rent_orders.map(String);
        this.tmp_all_liquidations.filters = { ...this.filters };
      }
      if (this.item_all === "all") {
        this.data.liquidation = this.tmp_all_liquidations.data;
      } else {
        this.data.liquidation = [];
      }
    },
    formatUSD(value) {
      return format(Number(value).toFixed(2), {
        code: "USD",
        decimal: ",",
        thousand: ".",
        format: "%s %v",
      });
    },
    validateLiquidateChecked(item) {
      let resp = false;
      if (
        item.status_payment === "paid" ||
        item.status_payment === "finished" 
      ) {
        resp = true;
      }
      return resp;
    },
  },
};
</script>
